class ResizeTopBar{

    //1. Describe and initiate our object
    constructor() {
        this.navbar = document.getElementById('navbar');
        this.events();
    }

    // 2. Events
    events() {
        window.addEventListener('scroll', this.updateScroll);
    }

    // 3. methods (function, action...)
    updateScroll() {
        if ( window.scrollY > 60) {
            this.navbar.classList.remove('lg:pt-8');
        } else {
            this.navbar.classList.add('lg:pt-8');
        }

    }
}

export default ResizeTopBar
